import { useRef, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useMatch,
  matchPath,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { TopBar } from "./components/Topbar/Topbar";
import { MySidebar } from "./components/MySidebar/MySidebar";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
import { GlobalStyles } from "./styles/GlobalStyles";
import styled from "styled-components";
import { appRoutes } from "./routes/appRoutes";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "components/PrivateRoute/PrivateRoute";
import NotFoundPage from "pages/NotFoundPage/NotFound";
import LoginPage from "pages/Login/Login";

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
`;

const MainContent = styled.main`
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const AppLayout: React.FC = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const location = useLocation();

  const definedPaths = appRoutes.map((r) => r.path);

  const isLoginPage = location.pathname === "/login";

  const isDefinedRoute = definedPaths.some((pattern) =>
    matchPath({ path: pattern, end: true }, location.pathname)
  );

  const isMinimalLayout = isLoginPage || !isDefinedRoute;

  return (
    <AppContainer>
      {!isMinimalLayout && (
        <MySidebar
          isMobileSidebarOpen={isMobileSidebarOpen}
          onClose={() => setIsMobileSidebarOpen(false)}
        />
      )}
      <MainContent>
        {!isMinimalLayout && (
          <TopBar
            onSidebarToggle={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          />
        )}
        <Routes>
          {/* ✅ Protected routes */}
          <Route element={<PrivateRoute />}>
            {appRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>

          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </MainContent>
    </AppContainer>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AppLayout />
          </BrowserRouter>
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
